import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PontosCriticosProjetoService } from '../services/pontos-criticos-projeto.service';


@Injectable({
  providedIn: 'root'
})
export class PontosCriticosIndicadorResolver implements Resolve<boolean> {

  constructor(private service: PontosCriticosProjetoService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getIndicadorById(route.params.idPontoCriticoIndicador);
  }
}